export default "__VITE_ASSET__dxqKB1QL__"